import AlbumFolderSearchResult from './AlbumFolderSearchResult';

export default AlbumFolderSearchResult;
